/**
 * Причина провала запроса Справочников человеческими словами (05.10.2026). У ОО сервер отвечал
 * 403 «нет прав», а экран писал «ошибка сети, проверьте связь» — Саша девять раз жал «Сохранить»
 * в карточке «Жидкое мыло», думая, что виновата связь. «Сеть» — только когда ответа не было вовсе.
 */
import { ApiException } from "../../api/types";

/** Право из «Нет прав на write:quests» → кто это меняет. */
const RIGHTS: Record<string, string> = {
  "write:quests": "потребителей расходника меняет ЕО",
  "write:mc": "потребителей расходника меняет ЕО",
  "write:resources": "ресурсы меняет ЕО",
  "write:consumables": "расходники меняют ОО и ЕО",
};

export function dictErr(e: unknown): string {
  if (!(e instanceof ApiException)) return "нет связи с сервером — проверьте интернет и повторите";
  const msg = String(e.body?.error ?? "").trim();
  if (e.status === 403) return `нет прав: ${(RIGHTS[msg.replace(/^Нет прав на /, "")] ?? msg) || "доступ закрыт"}`;
  if (e.status === 404) return "не найдено — возможно, уже удалено; потяните список вниз, чтобы обновить";
  if (e.status >= 500) return `сбой на сервере (${e.status}) — повторите чуть позже`;
  return msg || `сервер отказал (${e.status})`;
}
